export default __webpack_public_path__ + "static/iconfinder_12_3319602-56066954cce943acd76b4c5d2d946ccb.png";